import { cn } from "../../utils/utils";

export const LoadingSpinner = ({ className }) => {
  return (
    <div className="flex justify-center items-center">
      <div
        className={cn(
          `
          w-12 h-12
          border-primary
          border-2
          border-t-transparent
          rounded-full
          animate-spin
        `,
          className,
        )}
      />
    </div>
  );
};
